import React from 'react';
import Loadable from 'react-loadable';
import LoadableLoading from 'components/LoadableLoading';

export const path = '/calculator-tariff/:projectGuid/result/:resultId/calculation';
export const getPath = (projectGuid: string, resultId: number) =>
  `/calculator-tariff/${projectGuid}/result/${resultId}/calculation`;

const PageCalculation: React.FC = (props) => {
  const Calculation = Loadable({
    loader: () => import('./page'),
    loading: LoadableLoading,
  });

  return <Calculation {...props} />;
};

export default PageCalculation;
